// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"cd7981f3","626":"0475ba34","651":"98fae5e3"}[chunkId] + ".chunk.js";
};